export default __webpack_public_path__ + "images/green-70.png";